import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { PatientActions } from 'src/redux/actions/constant';
import patientService from 'src/services/apiServices/patientService';


const {
  GET_PAYER_PLAN_TYPE_REQUEST,
  GET_PAYER_PLAN_TYPE_SUCCESS,
  GET_PAYER_PLAN_TYPE_FAILURE
} = PatientActions;

function* getPayerPlanType(): SagaReturnType<any> {
  try {
    // yield put({ type: LOADER_ON });
    const response = yield call(
      patientService.getPayerPlanType
    );
    if (response?.status === 200) {
      yield put({ type: GET_PAYER_PLAN_TYPE_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_PAYER_PLAN_TYPE_FAILURE, payload: error });
  } finally {
    // yield put({ type: LOADER_OFF });
  }
}

function* getPayerPlanTypeSaga() {
  yield takeEvery(GET_PAYER_PLAN_TYPE_REQUEST, getPayerPlanType);
}

export default getPayerPlanTypeSaga;
